import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    window.open('https://api.whatsapp.com/send?phone=3477030346', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleWhatsAppClick}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 animate-pulse"
        aria-label="Contattaci su WhatsApp"
        title="Chatta con noi su WhatsApp"
      >
        <MessageCircle className="h-8 w-8" />
        <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold animate-bounce">
          !
        </div>
      </button>
      
      {/* Indicatore "Scrivi" */}
      <div className="absolute -left-20 top-1/2 transform -translate-y-1/2 bg-white text-green-600 px-3 py-2 rounded-lg shadow-lg text-sm font-semibold opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Scrivi su WhatsApp
      </div>
    </div>
  );
};

export default WhatsAppFloat;